// extracted by mini-css-extract-plugin
export var excerpt = "student-preview-module--excerpt--giQWW";
export var leadMediaThumb = "student-preview-module--leadMediaThumb--ASL8m";
export var leadMediaThumbFeatured = "student-preview-module--leadMediaThumbFeatured--n7-+m";
export var leadMediaThumbMasonry = "student-preview-module--leadMediaThumbMasonry--I7aIH";
export var root = "student-preview-module--root--iVBhq";
export var title = "student-preview-module--title--EmeFR";